import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { MotionTypographyComponent } from "../animations/components";

const SuspenseLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // full screen height
        maxWidth: "100vw", // full screen width
        width: "100%",
        flexDirection: "column",
        textAlign: "center",
        bgcolor: "background.default",
        color: "text.primary",
        p: 2,
        overflowX: "hidden",
      }}
    >
      <CircularProgress
        size={80} // Size of the loader
        thickness={5} // Thickness of the spinner
        sx={{
          mb: 3,
          animation: "spin 2s linear infinite", // Customize the spinning animation
        }}
      />
      <MotionTypographyComponent
        variant="h6"
        sx={{ fontWeight: "bold", maxWidth: "lg" }}
      >
        Пока загружается сайт, наши мастера уже чинят трубы, устанавливают
        сантехнику и спасают мир от потопов. Профессионализм - наше второе имя!
      </MotionTypographyComponent>
    </Box>
  );
};

export default SuspenseLoader;
